/**
 * ResetPasswordControl
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import { EMPLOYEE_ROLE, STUDENT_ROLE, PARENT_ROLE } from 'containers/User/constants.js';
import messages from '../messages.js';
import ResetPasswordModal from './ResetPasswordModal.jsx';
import ResetPasswordLinkModal from './ResetPasswordLinkModal.jsx';

function ResetPasswordControl(props) {
  const { user, ...rest } = props;
  const [show, setShow] = useState(false);
  const { roleType, uniqueId } = user;
  if (!uniqueId) {
    return null;
  }
  if (!uniqueId || ![EMPLOYEE_ROLE, STUDENT_ROLE, PARENT_ROLE].includes(roleType)) {
    return null;
  }
  return (
    <>
      <Button {...rest} onClick={() => setShow(true)}>
        <FormattedMessage {...messages.resetPassword} />
      </Button>
      {roleType === PARENT_ROLE
        ? <ResetPasswordLinkModal user={show ? user : null} onHide={() => setShow(false)} />
        : <ResetPasswordModal user={show ? user : null} onHide={() => setShow(false)} />}
    </>
  );
}

ResetPasswordControl.propTypes = {
  user: PropTypes.object,
};

export default ResetPasswordControl;
